import React from 'react'
import { RouteComponentProps } from "react-router-dom";
import Game from './features/game/Game';

interface GameRouteParams {
    gameId: string
}

interface GameRouteProps extends RouteComponentProps<GameRouteParams> {}

export default function GameRoute({ match: { params: { gameId } } }: GameRouteProps ) {
    return <Game id={gameId} />
}